import styled from 'styled-components';

const Wrapper = styled.div<{ $isActive?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 4px;
  background: ${(props) => (
    props.$isActive ? props.theme.colors.main_cta_light : props.theme.colors.widget_background
  )};
  border-radius: 100px;
  border: ${(props) => (props.$isActive ? `1px solid ${props.theme.colors.main_cta}` : '1px solid transparent')};
  color: ${(props) => (
    props.$isActive ? props.theme.colors.main_cta : props.theme.colors.text
  )};
  transition: all .2s ease-in;

  &:hover {
    color: ${(props) => props.theme.colors.main_cta};
    background: ${(props) => props.theme.colors.main_cta_light};
  }
`;

const Download = styled.div`
  margin: 30px 0 60px 0;

  p {
    text-align: center;
  }

  button {
    padding: 10px;
    border: 1px solid ${(props) => props.theme.colors.red};
    border-radius: 50px;
    display: block;
    margin: 0 auto;
    margin-top: 20px;
  }

  .error {
    color: ${(props) => props.theme.colors.red};
  }
`;

export default { Wrapper, Download };
